import { render, staticRenderFns } from "./ConsumablesPanel.vue?vue&type=template&id=0826281a&scoped=true&"
import script from "./ConsumablesPanel.vue?vue&type=script&lang=js&"
export * from "./ConsumablesPanel.vue?vue&type=script&lang=js&"
import style0 from "./ConsumablesPanel.vue?vue&type=style&index=0&id=0826281a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826281a",
  null
  
)

export default component.exports